module.exports = __webpack_public_path__ + "img/reason_img2.1e556e82.png";